<template>
	<div>
		<v-card>
			<s-crud title="Guías de remisión" :config="config" :filter="filter" add edit
				@edit="openEditDialogReferralGuide()" remove add-no-function @add="openDialogReferral()"
				ref="crudguideremision" @rowSelected="rowSelected($event)" sync pdf @pdf="downloadGuide()"
				@sync="syncDoc()" search-input>
				<!--:print="this.referralGuideSelected.RegState == 1 || this.referralGuideSelected.RegState == 2 || 
			this.referralGuideSelected.RegState == 3 || this.referralGuideSelected.RegState == 5 || 
			this.referralGuideSelected.RegState == 7" 
			@print="openFile()" -->
				<template v-slot:options>
					<v-tooltip bottom="">
						<template v-slot:activator="{ on }">
							<v-btn v-on="on" text black @click="lowGuide()" small>
								<v-icon style="font-size: 16px !important">mdi-cancel</v-icon>
							</v-btn>
						</template>
						<span>Dar Baja{{ lengthSelected }}</span>
					</v-tooltip>

				</template>

				<template v-slot:filter>
					<v-container>
						<v-row>
							<!--  -->
							<v-col v-if="$fun.isAdmin()">
								<s-select-area v-model="filter.AreID" label="Área" />
							</v-col>
							<v-col>
								<s-date label="Fecha Inicio" v-model="filter.DateBegin"></s-date>
							</v-col>
							<v-col>
								<s-date label="Fecha Fin" v-model="filter.DateEnd"></s-date>
							</v-col>
							<v-col>
								<s-select-definition label="Tipo Guía" :def="1411" v-model="filter.TypeGuide"
									clearable></s-select-definition>
							</v-col>
							<v-col>
								<s-select-definition :def="1412" label="Estados de Guía" clearable
									v-model="filter.RegState"></s-select-definition>
							</v-col>
						</v-row>
					</v-container>
				</template>


				<!--<template v-slot:Generate = "{ row }">-->

				<template v-slot:Actions="{ row }">
					<v-btn x-small color="warning" class="mr-2" @click="generateXml(row)" v-if="row.RegState != 7"
						:disabled="row.RegState == 1 || row.RegState == 2 || row.RegState == 3 || row.RegState == 5 || row.RegState == 7">
						<!-- :disabled="row.RegState != 2" -->
						<v-icon style="font-size: 16px !important">mdi-note-outline</v-icon>
					</v-btn>

					<!--</template>
<template v-slot:View="{ row }"> -->

					<!-- <v-btn x-small color="success" @click="downloadFile(row)">
						<v-icon style="font-size: 16px !important">far fa-eye</v-icon>
					</v-btn> -->
					<v-btn x-small color="primary" class="mr-2" @click="updateStateFacele(row)"
						v-if="(row.RegState == 1 || row.RegState == 2) && row.RegNumber != null">
						<v-icon style="font-size: 16px !important">mdi-reload</v-icon>
					</v-btn>
					<!---->
					<v-tooltip bottom="">
						<template v-slot:activator="{ on }">
							<v-btn x-small color="info" class="mr-2" @click="downloadGuide(row)" v-on="on"
								v-if="row.RegState == 7">
								<v-icon style=" font-size: 16px !important">mdi-file-pdf-box</v-icon>

							</v-btn>
						</template>
						<span>DESCARGAR EN PDF</span>
					</v-tooltip>
					<v-tooltip bottom="">
						<template v-slot:activator="{ on }">
							<v-btn x-small color="success" class="mr-2" @click="downloadGuideXml(row)" v-on="on"
								v-if="row.RegState == 7">
								<v-icon style=" font-size: 16px !important">mdi-file-xml-box</v-icon>

							</v-btn>
						</template>
						<span>DESCARGAR EN XML</span>
					</v-tooltip>
				</template>

				<template v-slot:RegState="{ row }">
					<v-chip :color="row.RegStateColor" x-small>
						{{ row.RegStateName }}
					</v-chip>
				</template>
				<template v-slot:xRegSerie="{ row }">
					<v-chip :color="'info'" x-small>
						{{ row.RegSerie }}
					</v-chip>
				</template>
				<template v-slot:xRegNumber="{ row }">
					<v-chip :color="'info'" x-small>
						{{ row.RegNumber }}
					</v-chip>
				</template>

			</s-crud>

			<!-- Guía de remisión remitente -->
			<v-dialog v-if="dialogReferral" v-model="dialogReferral" fullscreen persistent>
				<lgs-referral-guide-create v-if="!isEdit" @closeDialogReferral="closeDialogReferral()"
					@refreshTable="refreshTable()"></lgs-referral-guide-create>
				<lgs-referral-guide-edit v-else @closeDialogReferral="closeDialogReferral()"
					:referralGuideSelected="referralGuideSelected" :typeGuide="1"></lgs-referral-guide-edit>
			</v-dialog>
			<v-dialog v-if="dialogGuidePdf" v-model="dialogGuidePdf" fullscreen persistent>
				<guide-pdf :referralGuideSelected="referralGuideSelected" @close="dialogGuidePdf = false"></guide-pdf>
			</v-dialog>
		</v-card>
	</div>
</template>

<script>
import _sReferral from "@/services/Logistics/LgsReferralGuideService.js";
import LgsReferralGuideCreate from './LgsReferralGuideCreate.vue';
import LgsReferralGuideEdit from './LgsReferralGuideEdit.vue';
import GuidePdf from './LgsPrintGuidePdf.vue';

export default {
	components: {
		LgsReferralGuideCreate,
		LgsReferralGuideEdit,
		GuidePdf
	},

	data() {
		return {
			lengthSelected: 0,
			dialogReferral: false,
			typeReferralGuide: 0,
			isEdit: false,
			filter: {
				TypeAreGuide: "",
				UsrID: this.$fun.getUserID(),
				TypeGuide: 0,
				StatusAreaGuide: 0,
			},
			config: {
				model: {
					RegID: "ID",
					View: "",
					Generate: "",
					Actions: "",
					RegState: "",
					RespFacele: "",
					RegDate: "date",
					xRegSerie: "",
					xRegNumber: "",
					RegDatePortal: "datetime",
				},
				service: _sReferral,
				headers: [
					//{text : '', value : 'Generate'},
					{ text: '', value: 'Actions' },
					{ text: 'ID', value: 'RegID' },
					{ text: 'Serie', value: 'xRegSerie' },
					{ text: 'Correlativo', value: 'xRegNumber' },
					{ text: 'Fecha Emision', value: 'RegDate' },
					{ text: 'Area', value: 'TypeAreGuideName' },
					{ text: 'Nombre de destinatario', value: 'RegBusinessNameDestination' },
					{ text: 'Documento de destinatario', value: 'RegDocumentNumberDestination' },
					{ text: 'Peso', value: 'RegGrossWeightCargo' },
					{ text: 'Motivo', value: 'TypeTransferReasonCodeName' },
					// {text : 'Motivo', value : 'TypeTransferReasonName'} ,
					{ text: 'Transporte', value: 'RegBusinessNameTransport' },
					{ text: 'Observación Fac.', value: 'RespFacele' },
					{ text: 'Estado', value: 'RegState' },
					{ text: 'Fecha Portal', value: 'RegDatePortal' },
				]
			},
			referralGuideSelected: {},
			dialogGuidePdf: false,
			pathPdfFacele: "",
		}
	},

	methods: {
		openFile() {
			_sReferral
				.documentPdf(this.referralGuideSelected, this.$fun.getUserID())
				.then(r => {
					this.$fun.download(r.data, "GR " + this.referralGuideSelected.RegSerie + "-" + this.referralGuideSelected.RegNumber + ".xml");
				});
			// _sGeneral.download(url.name, this.$fun.getUserID()).then((r) => {
			// 	this.$fun.download(r.data, url.name);
			// });
		},
		refreshTable() {
			this.$refs.crudguideremision.refresh();
		},
		syncDoc() {
			_sReferral
				.refresh(this.$fun.getUserID())
				.then(resp => {
					if (resp.status == 200) {
						this.$fun.alert("Sincronizado correctamente", "success");

					}
				})
		},
		lowGuide() {
			if (this.referralGuideSelected.RegID == undefined) {
				this.$fun.alert("Selecciona una guía", "warning");
				return;
			}
			this.$fun.alert("¿Seguro de dar de baja?", "question")
				.then(r => {
					if (r.value) {
						this.referralGuideSelected.RegState = 3;
						this.referralGuideSelected.UsrUpdateID = this.$fun.getUserID();
						_sReferral
							.save(this.referralGuideSelected, this.$fun.getUserID())
							.then(resp => {
								if (resp.status == 200) {
									this.$fun.alert("Guía dado de baja correctamente", "success");
									this.$refs.crudguideremision.refresh();
								}
							})
					}
				})
		},

		updateStateFacele(item) {
			console.log("item", item);
			if (item.RegState == 2) {
				_sReferral
					.updatestatesunat(item, this.$fun.getUserID(), item.RegNumber)
					.then(resp => {
						if (resp.status == 200) {
							console.log("resp", resp);
							const data = resp.data;
							const accion = data.accion;

							if (accion === "CONSULTADO") {
								// Existe en Facele, mostramos el estado SUNAT
								const iconMap = { "2": "success", "4": "success", "1": "warning" };
								const tipo = iconMap[data.estadoSunat] || "info";
								this.$fun.alert(
									`[Facele - Estado SUNAT: ${data.estadoSunat}]\n${data.descripcion || "Sin descripción"}`,
									tipo
								);
							} else if (accion === "REENVIADO") {
								// El XML no estaba en Facele pero se reenvió exitosamente
								this.$fun.alert(
									`✅ El documento fue reenviado a Facele.\n${data.descripcion}`,
									"success"
								);
							} else if (accion === "SIN_XML") {
								// No existe en Facele y tampoco hay XML en disco
								this.$fun.alert(
									`⚠️ No existe en Facele y no se encontró el XML en disco.\n${data.descripcion}`,
									"warning"
								);
							} else if (accion === "ERROR_REENVIO") {
								// Intento de reenvío falló
								this.$fun.alert(
									`❌ Error al reenviar a Facele.\n${data.descripcion}`,
									"error"
								);
							} else {
								// SIN_REGISTRO_FACELE u otro estado
								this.$fun.alert(
									`[Cód.Facele: ${data.codigoRespuestaFacele}] ${data.descripcionFacele || data.descripcion}`,
									"info"
								);
							}
							this.$refs.crudguideremision.refresh();
						}
					});
			}
			else {
				_sReferral
					.updatestatefacele(item, this.$fun.getUserID(), item.RegNumber)
					.then(resp => {
						if (resp.status == 200) {
							this.$refs.crudguideremision.refresh();
						}
					})
			}

		},

		rowSelected(referralGuide) {
			console.log('referralGuide ', referralGuide);
			if (referralGuide.length > 0) {
				this.lengthSelected = referralGuide.length;
				this.referralGuideSelected = referralGuide[0];
				this.referralGuideSelected.TypeGuide = 1;


				console.log("this.referralGuideSelected", this.referralGuideSelected)



				_sReferral
					.detail(this.referralGuideSelected, this.$fun.getUserID())
					.then(resp => {
						if (resp.status == 200) {
							this.referralGuideSelected.referralGuideItems = resp.data;
						}
					});

				_sReferral
					.relateddocuments(this.referralGuideSelected, this.$fun.getUserID())
					.then(resp => {
						if (resp.status == 200) {
							this.referralGuideSelected.itemsRelatedDocuments = resp.data;
						}
					});

				_sReferral
					.vehicles(this.referralGuideSelected, this.$fun.getUserID())
					.then(resp => {
						if (resp.status == 200) {
							console.log('vehiculos', resp.data);
							this.referralGuideSelected.LgsReferralGuideVehicles = resp.data;
						}
					});

				_sReferral
					.drivers(this.referralGuideSelected, this.$fun.getUserID())
					.then(resp => {
						if (resp.status == 200) {
							this.referralGuideSelected.LgsReferralGuideDrivers = resp.data;
						}
					});

				//armamos la serie
				let objSerie = {
					DedDescription: this.referralGuideSelected.RegSerie,
					DedValue: this.referralGuideSelected.RegSerieID,
				}
				this.referralGuideSelected.objSerie = objSerie;
				this.referralGuideSelected.DtrIDStartPointOriginal = this.referralGuideSelected.DtrIDStartPoint;
			}
		},
		downloadGuideXml() {
			if (this.referralGuideSelected.RegID != undefined) {
				if (this.referralGuideSelected.RegState == 7) {
					_sReferral.xmlSunat(this.referralGuideSelected, this.$fun.getUserID())
						.then((r) => {
							if (r.status === 200 && r.data) {
								// const blob = new Blob([r.data], { type: "application/xml" });
								const filename = `Guia-${this.referralGuideSelected.RegSerie}-${this.referralGuideSelected.RegNumber}.xml`;
								this.$fun.download(r.data, filename);
							} else {
								console.error("Error al obtener XML:", r);
							}
						})
						.catch((error) => {
							console.error("Error en la solicitud XML:", error);
						});
				} else {
					this.referralGuideSelected.urlSunat = "";
					//this.dialogGuidePdf = true;	
				}
			}
		},
		downloadGuide() {
			if (this.referralGuideSelected.RegID != undefined) {
				if (this.referralGuideSelected.RegState == 7) {
					_sReferral.urlSunat(this.referralGuideSelected, this.$fun.getUserID()).then((r) => {

						if (r.status == 200) {
							console.log('ressss', r.data);
							this.referralGuideSelected.urlSunat = r.data;
							this.dialogGuidePdf = true;
						}
					})
				} else {
					this.referralGuideSelected.urlSunat = "";
					this.dialogGuidePdf = true;
				}


			}
		},
		openDialogReferral() {
			this.dialogReferral = true;
		},

		openEditDialogReferralGuide() {
			this.isEdit = true;
			this.dialogReferral = true;
		},

		closeDialogReferral() {
			this.$refs.crudguideremision.refresh();
			this.dialogReferral = false;
			this.isEdit = false;

		},

		generateXml(guide) {
			console.log("genreate", guide)
			this.$fun.alert("¿Seguro de generar?", "question").then(r => {
				if (r.value) {
					_sReferral.generateXml(guide, this.$fun.getUserID()).then((r) => {

						if (r.status == 200) {
							this.$refs.crudguideremision.refresh();
						}
					});
				}
			})
		},

		downloadFile(guide) {
			console.log("downloadFile", guide)
			this.$fun.alert("¿Seguro de descargar el documento?", "question").then(r => {
				if (r.value) {
					const params = {
						RegID: guide.RegID,
						Format: 1,
						RegSerie: guide.RegSerie,
						RegNumber: guide.RegNumber,
						RegFileExtencion: "xml"
					}
					console.log("params", params)
					_sReferral.downloadFile(params, this.$fun.getUserID()).then((r) => {
						console.log("r", r)
						if (r.status == 200) {
							const url = window.URL.createObjectURL(new Blob([r.data]));
							const link = document.createElement('a');
							link.href = url;
							const prefix = params.Format == 6 ? 'R-' : '';
							link.setAttribute('download', `${prefix}${params.RegSerie}-${params.RegNumber}.${params.RegFileExtencion}`);
							document.body.appendChild(link);
							link.click();
							link.remove();
							// this.$refs.crudguideremision.refresh();
						}
					}).catch((error) => {
						console.error("Error al descargar el documento:", error);
					})
				}
			})
		},

		showPdf() {
			if (this.referralGuideSelected.RegID != undefined) {
				console.log("showPdf", this.referralGuideSelected)
				_sReferral.showPdf(this.referralGuideSelected, this.$fun.getUserID()).then((r) => {
					console.log("r", r)
					if (r.status == 200) {
						console.log('ressss', r.data);
						this.$fun.downloadFile(r.data, this.$const.TypeFile.PDF, "Guia Remision");
					}
				})
			}
		},

	},
	mounted() {
		let permis = 0;
		if (this.$fun.hasSpecialPermission("LGS")) {
			permis = 1
		}
		if (this.$fun.hasSpecialPermission("AT")) {
			permis = 2
		}
		if (this.$fun.hasSpecialPermission("COMEX")) {
			permis = 3
		}

		this.filter.TypeAreGuide = permis;
	},
	created() {

		console.log("persimtios", this.$fun.getSecurity())

		// if (!this.$fun.isAdmin()) this.filterRequirement.AreID = this.$fun.getUserInfo().CtrContract.AreID;
		var areAlow = this.$fun.getSecurity().AreasAllow;
		if (areAlow.length > 0) {

			if (!this.$fun.isAdmin()) this.filter.AreID = areAlow[0].AreID;
		}
	}
}
</script>
